<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Produto {{ dados.nome }}
					</h1>
				</div>
			    <div>
					<button 
						@click="update()"
						class="btn btn-primary mr-1">
						<i class="fas fa-edit"></i>
					</button>
					<button 
						@click="destroy()"
						class="btn btn-danger mr-1">
						<i class="fas fa-trash"></i>
					</button>
			    	<button 
				        @click="$router.go(-1)" 
				        class="btn btn-secondary">
			        	Voltar
			        </button>
			    </div>
			</div>
			<div class="card mb-4">
  				<div class="card-body">
    				<produto-info 
						:dados="dados" 
						:key="produtoInfoKey">
					</produto-info>
  				</div>
			</div>
			<material-card
				:key="materialCardKey"
				@reload="reload"
			></material-card>
			<div class="card mb-4">
		        <div class="card-header">
			    	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Imagens</strong>
			            </div>
			            <button class="btn btn-primary" @click="showUpload">Upload</button>
				    </div>
			    </div>
			    <div class="card-body">
			    	<produto-arquivo-upload 
			    		v-if="showUploadKey"
						:key="produtoArquivoUploadKey"
						@reload="reload">
					</produto-arquivo-upload>
			        <produto-imagem-table
						@show="showImage"
						:key="produtoImagemTableKey"
						@destroy="destroyImage"
						@reload="reload">
					</produto-imagem-table>
			    </div>
			</div>
		</div>
		<produto-imagem-show 
			:key="produtoImagemShowKey"
			:file="file">
		</produto-imagem-show>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_produto" 
        	:dado_id="$route.params.id" 
        	title="Deseja realmente excluir este produto?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/produtos/destroy/'" 
        	@reload="back()">
        </bsh-confirm>
        <bsh-confirm 
        	modal_id="confirm_destroy_produto_imagem" 
        	:dado_id="file.id" 
        	title="Deseja realmente excluir esta imagem?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/produto-imagens/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
		<produto-update 
			:dado_id="$route.params.id" 
			@reload="getDados">
		</produto-update>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				produtoArquivoUploadKey: 1,
				produtoImagemTableKey: 2,
				produtoImagemShowKey:3,
				materialCardKey: 4,
				produtoInfoKey: 5,
				file: 0,
				showUploadKey: false
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/produtos/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(){
				$('#update_produto').modal('show');
			},
			destroy(){
				$('#confirm_destroy_produto').modal('show');
			},
			showImage(file){
				this.file = file;
				$('#produto_show_imagem').modal('show');
			},
			destroyImage(file){
				this.file = file;
				this.produtoImagemShowKey++;
				$('#confirm_destroy_produto_imagem').modal('show');
			},
			showUpload(){
				this.showUploadKey = !this.showUploadKey;
			},
			back(){
				this.$router.go(-1)
			},
			reload(){
				this.getDados();
				this.produtoArquivoUploadKey++;
				this.produtoImagemTableKey++;
				this.materialCardKey++;
				this.produtoInfoKey++;
			}
		}
	}
</script>